import { Api } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateIndustriesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readIndustries(candidateId: Candidate['id']) {
    return super.read<{ data: Candidate['industries'] }>({
      endpoint: `/candidates/${candidateId}/industries`,
      method: 'GET',
    });
  }

  async refreshIndustries(candidateId: Candidate['id']) {
    return super.invalidate(`/candidates/${candidateId}/industries`);
  }
}

export const CandidateIndustriesApi = new CandidateIndustriesApiClass();
